/* eslint-disable css-modules/no-undef-class */
import classNames from 'classnames';
import Image from '@/components/atoms/image/image';
import styles from './numbered-sections-image-slider.module.scss';

export interface NumberedSectionsImageSliderProps {
  /** The index of the active image */
  activeImageIndex: number | null;
  /** The class name to apply to the component */
  className: string;
  /** An array of images to show */
  images: (Content.Properties.Image | null)[];
  /** The main image to show */
  mainImage: Content.Properties.Image | null;
}

const NumberedSectionsImageSlider = ({
  activeImageIndex,
  className,
  images,
  mainImage,
}: NumberedSectionsImageSliderProps) => {
  return (
    <div className={classNames(styles.component, className)}>
      <div className={styles.imageOverflowWrapper}>
        {mainImage && (
          <div className={classNames(styles.imageWrapper, styles.isActive)}>
            <Image
              alt={mainImage.altText}
              aspectRatio="threeByFour"
              className={styles.image}
              fill
              focalPoint={mainImage.focalPoint}
              height={438}
              src={mainImage.url}
              srcSet={{
                desktop: {
                  height: 722,
                  width: 541,
                },
                laptop: {
                  height: 500,
                  width: 375,
                },
                tablet: {
                  height: 454,
                  width: 341,
                },
              }}
              unoptimized
              width={328}
            />
          </div>
        )}

        {images.map((image, imageIndex) => {
          if (!image) return null;

          return (
            <div
              key={imageIndex}
              className={classNames(styles.imageWrapper, {
                [styles.isActive]:
                  activeImageIndex !== null && imageIndex <= activeImageIndex,
              })}
            >
              <Image
                alt={image.altText}
                aspectRatio="threeByFour"
                className={styles.image}
                fill
                height={438}
                src={image.url}
                srcSet={{
                  desktop: {
                    height: 722,
                    width: 541,
                  },
                  laptop: {
                    height: 500,
                    width: 375,
                  },
                  tablet: {
                    height: 454,
                    width: 341,
                  },
                }}
                unoptimized
                width={328}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

NumberedSectionsImageSlider.displayName = 'NumberedSectionsImageSlider';

export default NumberedSectionsImageSlider;
